export const SSO_AUTH_ERROR = "sso_auth_error";
export const FORBIDDEN_TENANT_ERROR = "forbidden_tenant_error";



// WEBPACK FOOTER //
// ./src/utils/auth/authErrorTypes.js